import { render, staticRenderFns } from "./Commentaires.vue?vue&type=template&id=3f580374&scoped=true&"
import script from "./Commentaires.vue?vue&type=script&lang=js&"
export * from "./Commentaires.vue?vue&type=script&lang=js&"
import style0 from "./Commentaires.vue?vue&type=style&index=0&id=3f580374&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f580374",
  null
  
)

export default component.exports